export const SET_CHARACTERS_DATA = '[CHARACTERS] SET_CHARACTERS_DATA';

export const setCharactersData = (data) => ({
  type: SET_CHARACTERS_DATA,
  payload: data,
});
